/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const StarOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Star outline"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M9.466 3.501c1.173-2.068 4.12-1.999 5.176.208l1.482 3.1 3.332.5c2.377.356 3.446 3.462 1.63 5.29l-2.388 2.4.562 3.38c.435 2.617-2.185 4.407-4.271 3.275L12 20.032l-2.989 1.622c-2.086 1.132-4.706-.658-4.271-3.275L5.3 15l-2.385-2.4c-1.817-1.828-.748-4.934 1.629-5.29l3.331-.5 1.483-3.1zm3.39 1.155a.942.942 0 0 0-1.713 0l-1.73 3.618-.059.105a.96.96 0 0 1-.661.434l-3.867.58c-.785.118-1.098 1.112-.53 1.683l2.798 2.816c.226.227.329.553.276.873l-.661 3.977c-.126.756.587 1.343 1.254 1.1l.133-.06 3.459-1.877a.93.93 0 0 1 .89 0l3.46 1.878c.657.356 1.418-.162 1.4-.892l-.014-.149-.66-3.977c-.054-.32.05-.646.275-.873l2.798-2.816c.568-.57.255-1.565-.53-1.683l-3.867-.58a.96.96 0 0 1-.662-.434l-.058-.105z"
      className="SVG"
    />
  </svg>
);

export const StarOutlineIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'star-outline-icon'}
      icon={StarOutline}
      {...props}
      size={size}
    />
  );
};
